import { render, staticRenderFns } from "./exitFactory.vue?vue&type=template&id=5b34d223&scoped=true&"
import script from "./exitFactory.vue?vue&type=script&lang=js&"
export * from "./exitFactory.vue?vue&type=script&lang=js&"
import style0 from "./exitFactory.vue?vue&type=style&index=0&id=5b34d223&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b34d223",
  null
  
)

export default component.exports